<section class="av-card p-4 d-flex flex-column gap-3">
  <div class="d-flex flex-wrap align-items-start justify-content-between gap-3">
    <div class="d-flex flex-column gap-1">
      <h2 class="av-section-title m-0">{{ 'backoffice.users.team.title' | translate }}</h2>
      <p class="av-meta m-0">{{ 'backoffice.users.team.scope_note' | translate }}</p>
    </div>

    <button type="button" class="av-btn" (click)="facade.reload()">
      <mat-icon aria-hidden="true">refresh</mat-icon>
      {{ 'backoffice.common.actions.refresh' | translate }}
    </button>
  </div>
</section>

<section class="av-card p-4 mt-3 d-flex flex-column">
  @switch (facade.state()) {
    @case ('error') {
      <av-empty-state
        icon="error_outline"
        [title]="'backoffice.users.team.error.title' | translate"
        [message]="'backoffice.users.team.error.message' | translate"
      ></av-empty-state>
    }
    @case ('ready') {
      @if (facade.isEmpty()) {
        <av-empty-state
          icon="badge"
          [title]="'backoffice.users.team.empty.title' | translate"
          [message]="'backoffice.users.team.empty.message' | translate"
        ></av-empty-state>
      } @else {
        <div class="table-scroll">
          <table class="av-table w-100">
            <thead>
              <tr>
                <th scope="col">{{ 'backoffice.users.team.columns.operator' | translate }}</th>
                <th scope="col">{{ 'backoffice.users.team.columns.system_role' | translate }}</th>
                <th scope="col">{{ 'backoffice.users.team.columns.app_status' | translate }}</th>
                <th scope="col">{{ 'backoffice.users.team.columns.created' | translate }}</th>
                <th scope="col" class="text-end">
                  {{ 'backoffice.users.team.columns.actions' | translate }}
                </th>
              </tr>
            </thead>

            <tbody>
              @for (operator of facade.operators(); track operator.id) {
                <tr>
                  <td>
                    <div class="d-flex flex-column">
                      <span class="cell-strong">{{ operator.fullName }}</span>
                      <span class="av-meta">{{ operator.email || unresolved }}</span>
                    </div>
                  </td>

                  <td>
                    <av-status-chip
                      [label]="operator.systemRoleLabelKey | translate"
                      tone="info"
                    ></av-status-chip>
                  </td>

                  <td class="cell-muted">{{ operator.appStatusLabelKey | translate }}</td>

                  <td class="cell-muted">
                    {{
                      operator.created_at ? (operator.created_at | date: dateFormat) : unresolved
                    }}
                  </td>

                  <td class="text-end">
                    @if (facade.canAssignRoles()) {
                      <button
                        type="button"
                        class="av-btn"
                        [matTooltip]="'backoffice.users.team.change_role' | translate"
                        [disabled]="facade.isMutating()"
                        (click)="openRoleDialog(operator)"
                      >
                        <mat-icon aria-hidden="true">manage_accounts</mat-icon>
                      </button>
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    }
    @default {
      <av-empty-state
        icon="hourglass_empty"
        [title]="'backoffice.users.team.loading.title' | translate"
        [message]="'backoffice.users.team.loading.message' | translate"
      ></av-empty-state>
    }
  }
</section>
